import { apiFetch } from './api';
import type { PackCreateInput, PackUpdateInput } from './resource-packs.service';

export interface BehaviorPack {
  id: string;
  projectId: string;
  name: string;
  fileName: string;
  description?: string;
  repository: string;
  currentVersion?: string;
  latestAvailable?: string;
  sizeMb?: number;
  attachedToContainers?: string[];
  lastSyncAt?: string;
  lastUpdateAt?: string;
  lastUpdateBy?: string;
}

const baseUrl = (pid: string) => `/api/projects/${pid}/behavior-packs`;

export const behaviorPacksService = {
  list: (pid: string) => apiFetch<BehaviorPack[]>(baseUrl(pid)),
  get: (pid: string, id: string) => apiFetch<BehaviorPack>(`${baseUrl(pid)}/${id}`),
  create: (pid: string, input: PackCreateInput) =>
    apiFetch<BehaviorPack>(baseUrl(pid), { method: 'POST', json: input }),
  update: (pid: string, id: string, input: PackUpdateInput) =>
    apiFetch<BehaviorPack>(`${baseUrl(pid)}/${id}`, { method: 'PATCH', json: input }),
  remove: (pid: string, id: string) =>
    apiFetch<void>(`${baseUrl(pid)}/${id}`, { method: 'DELETE' }),
  sync: (pid: string, id: string) =>
    apiFetch<BehaviorPack>(`${baseUrl(pid)}/${id}/sync`, { method: 'POST' }),
  syncAll: (pid: string) =>
    apiFetch<{ ok: number; ko: number; errors: string[] }>(`${baseUrl(pid)}/sync`, { method: 'POST' }),
};
